module.exports = __webpack_public_path__ + "static/media/medocs_02_thumb.74dd99c5.png";